// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bsUEWH {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-4);
  padding: var(--spacing-3);
  background-color: var(--surface-neutral-white, #fff);
  border-radius: var(--radius-m, 8px);
}

.S8FoCz {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.MF4_QM {
  width: 22px !important;
  height: 22px !important;
  flex-shrink: 0;
}

.PNqjVF {
  font-family: var(--font-family-clario);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark);
  margin: 0;
}

.jHN9Uy {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.tPBKl7 {
  border-bottom: 1px solid var(--stroke-neutral-silver, #cccccc);
}

.DuZ_v3 {
  border-bottom-color: transparent;
}

.wKbrHP {
  border-radius: 0 !important;
  background-color: var(--surface-neutral-white, #fff) !important;
  padding: var(--spacing-1-5) 0 !important;
  cursor: default !important;
  border: none !important;
}

.jHN9Uy [class*='inner'] {
  gap: var(--spacing-1);
}

.jHN9Uy [class*='title'] {
  flex: 1;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-auto);
  color: var(--text-neutral-dark);
}

.jHN9Uy [class*='contentExpanded'] {
  padding-top: var(--spacing-2);
}

.qi2RaF {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: transform var(--transition-normal);
}

.y3teYa {
  transform: rotate(180deg);
}

.ZQlJTj {
  display: block;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  padding: var(--spacing-2-5) var(--spacing-3) var(--spacing-1-5);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/FaqSection/FaqSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,oDAAoD;EACpD,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,+DAA+D;EAC/D,wCAAwC;EACxC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uCAAuC;EACvC,6CAA6C;EAC7C,mCAAmC;EACnC,+BAA+B;EAC/B,+DAA+D;AACjE","sourcesContent":[".faqSection {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-4);\n  padding: var(--spacing-3);\n  background-color: var(--surface-neutral-white, #fff);\n  border-radius: var(--radius-m, 8px);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n}\n\n.headerIcon {\n  width: 22px !important;\n  height: 22px !important;\n  flex-shrink: 0;\n}\n\n.title {\n  font-family: var(--font-family-clario);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.row {\n  border-bottom: 1px solid var(--stroke-neutral-silver, #cccccc);\n}\n\n.rowExpanded {\n  border-bottom-color: transparent;\n}\n\n.item {\n  border-radius: 0 !important;\n  background-color: var(--surface-neutral-white, #fff) !important;\n  padding: var(--spacing-1-5) 0 !important;\n  cursor: default !important;\n  border: none !important;\n}\n\n.list :global([class*='inner']) {\n  gap: var(--spacing-1);\n}\n\n.list :global([class*='title']) {\n  flex: 1;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-auto);\n  color: var(--text-neutral-dark);\n}\n\n.list :global([class*='contentExpanded']) {\n  padding-top: var(--spacing-2);\n}\n\n.itemIcon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  transition: transform var(--transition-normal);\n}\n\n.itemIconOpen {\n  transform: rotate(180deg);\n}\n\n.answer {\n  display: block;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  padding: var(--spacing-2-5) var(--spacing-3) var(--spacing-1-5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faqSection": `bsUEWH`,
	"header": `S8FoCz`,
	"headerIcon": `MF4_QM`,
	"title": `PNqjVF`,
	"list": `jHN9Uy`,
	"row": `tPBKl7`,
	"rowExpanded": `DuZ_v3`,
	"item": `wKbrHP`,
	"itemIcon": `qi2RaF`,
	"itemIconOpen": `y3teYa`,
	"answer": `ZQlJTj`
};
module.exports = ___CSS_LOADER_EXPORT___;
